import { Outlet } from "react-router-dom";
import { USQSProvider } from "../../contexts/USQSProvider";
import { USQSUndoProvider } from "../../contexts/USQSUndoProvider";

const QSOutlet = () => {
  return (
    <>
      {/* <USQSProvider>
        <USQSUndoProvider> */}
      <Outlet />
      {/* </USQSUndoProvider>
      </USQSProvider> */}
    </>
  );
};

export default QSOutlet;
